<script setup lang="ts">
import RialticLogo from './RialticLogo.vue'

defineProps<{
  message?: string
  title?: string
}>()
</script>

<template>
  <div
    class="bg-surface font-poppins flex h-screen flex-col p-10 text-[16px] sm:h-[540px] sm:rounded-xl sm:shadow-xl"
  >
    <header :class="{ 'pb-5': message }">
      <RialticLogo />
      <h1
        class="mt-6 mb-4 text-[24px] leading-9 font-semibold tracking-normal text-neutral-900"
      >
        {{ title || 'Welcome' }}
      </h1>
      <p v-if="message" class="text-sm leading-[21px] text-neutral-700">
        {{ message }}
      </p>
    </header>
    <slot />
  </div>
</template>
